import React from 'react'
import {FormatNumber} from "../../helpers/Helpers";

class AutogeneratorList extends React.Component {

    render() {

        const {data} = this.props;

        return (

            <table className='custom-table'>
                <thead>
                <tr>
                    <th>Año</th>
                    <th>Mes</th>
                    <th>Importado</th>
                    <th>Exportado</th>
                    <th>Valor</th>
                </tr>
                </thead>
                <tbody>

                {data.map((val, index) => {
                    return (
                        <tr key={index}>
                            <td>{val.periodo}</td>
                            <td>{val.mesNombre}</td>
                            <td>{val.Importado}</td>
                            <td>{val.Exportado}</td>
                            <td>$ {FormatNumber.new(val.cuentaDetalleValoracion)}</td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        );
    }
}

export default AutogeneratorList